<template>
  <i v-if="isAdmin" class="bx bxs-star text-warning" aria-label="Administrator" title="Administrator" />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const isAdmin = computed(() => props.params.data?.Type === 'Admin')
</script>
